export const ADULT_RATING_AGE = 18;
export const NOT_ADULT_RATING_AGE = ADULT_RATING_AGE - 1;
